module.exports = __webpack_public_path__ + "img/notification-sidebar.670a0809.svg";